export enum EInsightCardType {
  PRIMARY_DOMAIN = 'PRIMARY_DOMAIN',
  ACCOUNT_PROFILE = 'ACCOUNT_PROFILE',
  NEW_CONNECTOR = 'NEW_CONNECTOR',
}
